import React, {useEffect, useState} from 'react';
import './PaymentOfInstallments.scss';
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../Loader";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import DynaButton from "../../DynaView/DynaButton";
import {useNavigate} from "react-router-dom";

const PaymentOfInstallments = () => {

  const navigateTo = useNavigate();
  const [sendData, setSendData] = useState({
    bankId: "",
  })
  const [isLoad, setIsLoad] = useState(false);
  const [initialData, setInitialData] = useState([])
  const [bankList, setBankList] = useState([]);
  const [componentData, setComponentData] = useState([])
  const [filter, setFilter] = useState({})

  const BankAndAgentList = async () => {
    const response = await _axios.get(prefixUrl() + "/insurance/?request=bankList");
    if (response.data.status) {
      setBankList(response.data.data)
    } else {
      toast.error(response.data.message)
    }
  }

  const getDetail = async () => {
    const response = await _axios.get(prefixUrl() + "/insurance/?request=companyInstallmentsTable&type=all");
    if (response.data.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void BankAndAgentList()
    void getDetail()
  }, []);

  useEffect(() => {
    if (initialData?.length > 0) {
      let temp = [...initialData]
      temp.forEach(item => {
        item.checked = false
      })
      setComponentData(temp)
    }
  }, [initialData]);

  const formDataHandler = async () => {
    if (sendData?.bankId === "") {
      return toast.error("حساب بانکی را انتخاب کنید")
    }

    let temp = []
    initialData.forEach((item) => {
      if (item.checked) {
        temp.push({id: item.id})
      }
    })

    if (temp.length === 0) {
      return toast.error("یک سطر را انتخاب کنید")
    }

    const Data = {
      request: "payCompanyInstallment",
      data: {
        bankId: sendData?.bankId,
        payments: temp,
      }
    }
    const response = await _axios.post(prefixUrl() + "/insurance/", Data)
    if (response?.data.status) {
      toast.success(response.data?.message)
      void getDetail()
    } else {
      toast.error(response?.data?.message)
    }
  }

  const filterHandler = (value, name) => {
    filter[name] = value
    setFilter({...filter})
  }

  useEffect(() => {
    if (Object.keys(filter).length > 0) {
      let temp = initialData;
      for (const key in filter) {
        temp = temp.filter((item) => {
          return item[key]?.toString().includes(filter[key].toString());
        });
      }
      setComponentData(temp);
    } else {
      setComponentData(initialData);
    }
  }, [filter, initialData]);

  const checkAllHandler = (data) => {
    let temp = [...componentData];
    temp.forEach((item) => {
      item.checked = data;
    })
    setComponentData(temp)
  }

  const rowClickHandler = (data) => {
    let temp = [...componentData];
    temp.forEach((item) => {
      if (item?.id === data.id) {
        item.checked = !data.checked;
      }
    })
    setComponentData(temp)
  }

  try {
    return (
      <>
        {isLoad ?
          <section className={"PaymentOfInstallments"}>
            <div className={"top-row"}>
              <DynaSelectBox options={bankList}
                             hasFilter={true}
                             label={"انتخاب بانک"}
                             className={"solid-dyna-input"}
                             value={sendData?.bankId}
                             onChange={(data) => setSendData({...sendData, bankId: data.value})}/>
            </div>
            <div className={"list-show"}>
              <ul>
                <li className={"header-class"}>
                  <div style={{width: "3%"}}></div>
                  <div style={{width: "20%"}}>نام مشتری</div>
                  <div style={{width: "17%"}}>تاریخ سررسید</div>
                  <div style={{width: "10%"}}>کد ملی</div>
                  <div style={{width: "20%"}}>نوع بیمه نامه</div>
                  <div style={{width: "20%"}}>عنوان سازمان</div>
                  <div style={{width: "10%"}}>مبلغ</div>
                </li>
                <li>
                  <div style={{width: "3%"}} className="check-box-cell">
                    <label className="container">
                      <input type="checkbox" onChange={(e) => checkAllHandler(e.target.checked)}/>
                      <div className="checkmark"></div>
                    </label>
                  </div>
                  <div style={{width: "20%"}}>
                    <input onChange={(e) => filterHandler(e.target.value, "personName")}/>
                  </div>
                  <div style={{width: "17%"}}>
                    <input onChange={(e) => filterHandler(e.target.value, "date")}/>
                  </div>
                  <div style={{width: "10%"}}>
                    <input onChange={(e) => filterHandler(e.target.value, "nationalId")}/>
                  </div>
                  <div style={{width: "20%"}}>
                    <input onChange={(e) => filterHandler(e.target.value, "insuranceType")}/>
                  </div>
                  <div style={{width: "20%"}}>
                    <input onChange={(e) => filterHandler(e.target.value, "organizationName")}/>
                  </div>
                  <div style={{width: "10%"}}></div>
                </li>
              </ul>
              <ul className={"body-ul"}>
                {componentData?.length > 0 && componentData?.map(((item, index) =>
                    <li key={index + "row"} onClick={() => rowClickHandler(item)}>
                      <div style={{width: "3%"}} className="check-box-cell">
                        <label className="container">
                          <input type="checkbox" checked={+item?.checked}/>
                          <div className="checkmark"></div>
                        </label>
                      </div>
                      <div style={{width: "20%"}}>{item?.personName}</div>
                      <div style={{width: "17%"}}>{item?.date}</div>
                      <div style={{width: "10%"}}>{item?.nationalId}</div>
                      <div style={{width: "20%"}}>{item?.insuranceType}</div>
                      <div style={{width: "20%"}}>{item?.organizationName}</div>
                      <div style={{width: "10%"}}>{UtilsFunctions.addCommas(item?.remaining)}</div>
                    </li>
                ))}
              </ul>
            </div>

            {componentData?.length > 0 &&
              <div className={"row-button"}>
                <DynaButton className={"insurance-button-cansel"}
                            type={"button"}
                            onClick={() => navigateTo(-1)}>انصراف</DynaButton>
                <DynaButton className={"insurance-button"}
                            type={"button"}
                            onClick={formDataHandler}>ثبت</DynaButton>
              </div>
            }
          </section> : <Loader/>}
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default PaymentOfInstallments;